import { render, staticRenderFns } from "./rejectWidget.vue?vue&type=template&id=50a2a301"
import script from "./rejectWidget.vue?vue&type=script&lang=js"
export * from "./rejectWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports